/**
 * Names of fields that can be rendered by the Member Form Field component.
 */
export var MemberFormFieldName;
(function (MemberFormFieldName) {
    /**
     * Renders a field for the member's street address.
     */
    MemberFormFieldName["Address"] = "Address";
    /**
     * Renders a field for the member's city.
     */
    MemberFormFieldName["City"] = "City";
    /**
     * Renders a field for the member's date of birth.
     */
    MemberFormFieldName["DateOfBirth"] = "DateOfBirth";
    /**
     * Renders a field for the member's external ID.
     */
    MemberFormFieldName["ExternalId"] = "ExternalId";
    /**
     * Renders a field for the member's family name.
     */
    MemberFormFieldName["FamilyName"] = "FamilyName";
    /**
     * Renders a field for the member's primary site.
     */
    MemberFormFieldName["PrimarySite"] = "PrimarySite";
    /**
     * Renders a field for the member's favourite genres.
     */
    MemberFormFieldName["FavouriteGenres"] = "FavouriteGenres";
    /**
     * Renders a field for the member's gender.
     */
    MemberFormFieldName["Gender"] = "Gender";
    /**
     * Renders a field for the member's given name.
     */
    MemberFormFieldName["GivenName"] = "GivenName";
    /**
     * Renders a field for the member's home phone number.
     */
    MemberFormFieldName["HomeNumber"] = "HomeNumber";
    /**
     * Renders a field for the member's mobile phone number.
     */
    MemberFormFieldName["MobileNumber"] = "MobileNumber";
    /**
     * Renders a field for the member's national ID.
     */
    MemberFormFieldName["NationalId"] = "NationalId";
    /**
     * Renders a field that allows the member to choose whether they are sent a newsletter.
     */
    MemberFormFieldName["Newsletter"] = "Newsletter";
    /**
     * Renders a field for the member's post code.
     */
    MemberFormFieldName["PostCode"] = "PostCode";
    /**
     * Renders a CAPTCHA field for security purposes.
     */
    MemberFormFieldName["Captcha"] = "Captcha";
    /**
     * Renders a field for the member's state.
     */
    MemberFormFieldName["State"] = "State";
    /**
     * Renders a field for the member's suburb.
     */
    MemberFormFieldName["Suburb"] = "Suburb";
    /**
     * Renders a field that allows the member to accept terms and conditions.
     */
    MemberFormFieldName["TermsAndConditions"] = "TermsAndConditions";
    /**
     * Renders a field that allows the member to choose whether they allow third-party profiling.
     */
    MemberFormFieldName["AllowThirdPartyProfiling"] = "AllowThirdPartyProfiling";
    /**
     * Renders a field that allows the member to choose whether they allow third-party contact.
     */
    MemberFormFieldName["AllowThirdPartyContact"] = "AllowThirdPartyContact";
})(MemberFormFieldName || (MemberFormFieldName = {}));
//# sourceMappingURL=name.js.map